export default __webpack_public_path__ + "static/media/f_md-9.06f68e18.svg";